import type { ReassignRequired, RequestFollows } from '@/types/invoice_purchase_order_association'

export const INVOICE_PO_REASSIGN_ERROR_CODE = 'invoice_purchase_order_reassignment'
export const INVOICE_RECEPTION_REASSIGN_ERROR_CODE = 'invoice_reception_reassignment'

interface FailedResponse {
  data?: {
    error_code?: string
    extra?: {
      previous_purchase_order_number?: string | null
      associated_by?: string | null
      associated_at?: string | null
      request_follows?: RequestFollows
      previous_request_number?: string | null
      next_request_number?: string | null
    }
  }
}

export function readReassignRequired(response?: FailedResponse): ReassignRequired | null {
  const data = response?.data
  if (!data || data.error_code !== INVOICE_PO_REASSIGN_ERROR_CODE) return null

  const extra = data.extra
  const number = extra?.previous_purchase_order_number
  const previousPurchaseOrder = number
    ? {
        number,
        associated_by: extra?.associated_by ?? null,
        associated_at: extra?.associated_at ?? null,
      }
    : null
  if (!previousPurchaseOrder && !extra?.previous_request_number) return null

  return {
    request_follows: extra?.request_follows ?? 'purchase_order',
    previous_purchase_order: previousPurchaseOrder,
    previous_request_number: extra?.previous_request_number ?? null,
    next_request_number: extra?.next_request_number ?? null,
  }
}
